var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeLoan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 44,
    viewBox: "0 0 47 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18959_440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3696 21.1321L24.0713 2.79877C23.8303 2.57113 23.5042 2.44336 23.1643 2.44336C22.8244 2.44336 22.4984 2.57113 22.2573 2.79877L2.95906 21.1321C2.74829 21.3659 2.63816 21.6667 2.65066 21.9743C2.66317 22.2819 2.7974 22.5737 3.02653 22.7914C3.25565 23.009 3.5628 23.1366 3.8866 23.1484C4.21039 23.1603 4.52698 23.0557 4.7731 22.8555L23.1579 5.38989L41.5427 22.8677C41.7888 23.0679 42.1054 23.1725 42.4292 23.1607C42.753 23.1488 43.0601 23.0213 43.2892 22.8036C43.5184 22.5859 43.6526 22.2941 43.6651 21.9865C43.6776 21.6789 43.5675 21.3782 43.3567 21.1443L43.3696 21.1321Z",
    fill: "#CE1111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0234 39.111H29.5907V26.8888H16.7252V39.111H10.2924V21.9999L7.7193 24.4443V39.111C7.7193 39.7593 7.99039 40.3811 8.47294 40.8395C8.95549 41.2979 9.60997 41.5554 10.2924 41.5554H19.2983V29.3332H27.0176V41.5554H36.0234C36.7059 41.5554 37.3603 41.2979 37.8429 40.8395C38.3254 40.3811 38.5965 39.7593 38.5965 39.111V24.151L36.0234 21.7065V39.111Z",
    fill: "#CE1111"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18959_440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.3158,
    height: 44,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLoan);
export default __webpack_public_path__ + "static/media/home_loan.40f3310fba16c5d34374d3bc7bdadd02.svg";
export { ForwardRef as ReactComponent };